<template>
  <div class="ContactSection">
    <div class="container">
      <h2 class="ContactTitle ">RacePark Waiver & Consent Form</h2>
      <template v-if="thankyouMessage == 'N'">
        <p class="redTitle ">
          Parent/Guardian or Permitted Carer Details
        </p>
        <p class="WhiteStandard-text">(If you are completing this form on behalf of a participant under the age of 18, or you have been granted permission from the child’s family.)</p>

        <!-- Form Block -->
        <b-row class="formBlockSection">
              <b-col id="myForm" lg="6" sm="12">
                  <b-form ref="formdata">
                      <b-form-group
                          label="First Name (*required)"
                          label-for="input-lazy"
                          class="mb-0 buyersName"
                      >
                          <b-form-input
                          id="input-lazy"
                          v-model="AdultFirstName"
                          lazy-formatter
                          :formatter="formatter"
                          required
                          ></b-form-input>
                      </b-form-group>
                      <b-form-group
                          label="Phone Number  (*required)"
                          label-for="input-lazy"
                          class="mb-0"
                      >
                          <b-form-input
                          id="input-lazy"
                          v-model="AdultPhone"
                          lazy-formatter
                          :formatter="formatter"
                          required
                          ></b-form-input>
                      </b-form-group>
                      <b-form-group
                          label="Date of Birth  (*required)"
                          label-for="input-lazy"
                          class="mb-0"
                      >
                          <b-form-datepicker id="datepicker-placeholder" placeholder="Date of Birth"  v-model="AdultDOB" class="mb-2"></b-form-datepicker>
                      </b-form-group>
                  </b-form>
              </b-col>
              <b-col id="myForm" lg="6" sm="12">
                  <b-form ref="formdata">
                      <b-form-group
                          label="Last Name  (*required)"
                          label-for="input-lazy"
                          class="mb-0 buyersName"
                      >
                          <b-form-input
                          id="input-lazy"
                          v-model="AdultSurnameName"
                          lazy-formatter
                          :formatter="formatter"
                          required
                          ></b-form-input>
                      </b-form-group>
                      <b-form-group
                          label="Email  (*required)"
                          label-for="input-lazy"
                          class="mb-0"
                          required
                      >
                          <b-form-input
                          id="input-lazy"
                          v-model="AdultEmail"
                          lazy-formatter
                          :formatter="formatter"
                          ></b-form-input>
                      </b-form-group>
                  </b-form>
              </b-col>
        </b-row>
        <b-row style="margin-top:30px">
          <b-col id="myForm" lg="12" sm="12">
              <b-form ref="formdata">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="status"
                      name="checkbox-1"
                      value="Y"
                      unchecked-value="N"
                      class="check"
                  >
                  <span class="gift">
                      Tick this checkbox if you are completing this form on behalf of a minor (Under 18 years of age)
                  </span>
                  </b-form-checkbox>
                  <div v-if="status != 'N'">
                      <p class="redTitle nonParent">
                          Participant Details
                      </p>
                      <p class="WhiteStandard-text">(Complete this section for the minor taking part in activities at RacePark.)</p>
                  </div>
              </b-form>
          </b-col>
        </b-row>
        <div v-if="status != 'N'">
          <b-row v-for="(i, index) in row" :key="index">
            <b-col lg="3">
                <b-form-group
                    label="First Name  (*required)"
                    label-for="input-lazy"
                    class="mb-0"
                >
                    <b-form-input
                        id="input-lazy"
                        v-model="i.nameForename"
                        lazy-formatter
                        :formatter="formatter"
                        required
                    ></b-form-input>
                </b-form-group>
                <!-- {{i.num}} -->
            </b-col>
            <b-col lg="3">
                <b-form-group
                    label="Surname Name  (*required)"
                    label-for="input-lazy"
                    class="mb-0"
                >
                    <b-form-input
                        id="input-lazy"
                        v-model="i.nameSurname"
                        lazy-formatter
                        :formatter="formatter"
                        required
                    ></b-form-input>
                </b-form-group>
                <!-- {{i.num}} -->
            </b-col>
            <b-col lg="3">
                <b-form-group
                    label="Date of Birth  (*required)"
                    label-for="input-lazy"
                    class="mb-0"
                    required
                >
                    <b-form-datepicker :id="'datepicker-placeholderRec' + index" placeholder="Date of Birth"  v-model="i.dob" class="mb-2"></b-form-datepicker>
                </b-form-group>
            </b-col>
            <b-col>
                <div class="cross" @click="removeRow(index)">
                  <img class="crossRow" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/12/Icon-akar-cross.png">
                </div>
            </b-col>
          </b-row>
          <template>
              <button v-b-modal.modal-3 class="showMore fullWidth minorButton" @click="addRow()">Add Another Minor </button>
          </template>
        </div>

        <!-- Terms and conditions Block -->
        <h2 class="ContactTitle Terms">RacePark Terms and Conditions</h2>

        <p class="WhiteStandard-text">
          <b>SimPark – Consent & Waiver Form (Ages 16and Over)</b><br>
            I wish to participate in the use of the simulators (collectively referred to as the “Activity”)
            at SimPark (“the Company”).<br>
            I confirm that I am sixteen (16) years of age or older. I agree to undertake the Activity in
            accordance with all rules and instructions provided to me prior to participation, including
            any instructions or advice issued before or during the session.<br>
            I acknowledge that I am responsible for my own safety while undertaking the Activity.<br>
            I certify that, to the best of my knowledge, I am in good physical condition and do not have
            any medical condition that may increase the likelihood of being involved in an incident
            resulting in injury to myself or others.<br>
            I certify that I have no pre-existing medical conditions or pregnancy that could, through
            participation in the Activity, result in injury to myself or harm to my health.<br>
            I acknowledge that the maximum permitted weight for participation in the Activity is
            135kg, and I confirm that I do not exceed this weight.<br>
        </p>
        <button @click="myFunction()" class="showMore" v-if="showButton == true">Show More</button>
        <div v-if="showDiv == true">
          <p class="WhiteStandard-text">
              <b>For Participants Under 16 Years Old</b><br>
                I am the parent/guardian of the child/children listed below who is/are under sixteen (16)
                years of age. I consent to their participation in the simulators (the “Activity”) at SimPark.<br>
                If I am not the parent or legal guardian, I declare that I have authority from the child/
                children’s parent or guardian to sign this risk acknowledgement form.<br>
                I acknowledge the risks of the Activity on their behalf.<br>
                I confirm that I am responsible for the child/children in my care and will ensure that they
                undertake the Activity in accordance with all safety rules and instructions provided before
                or during the session.<br>
                I acknowledge that I am responsible for the safety and supervision of the listed child/
                children (and for our possessions), and that SimPark does not provide supervision of
                children using the premises, attending unaccompanied, or left unaccompanied on the
                premises.<br>
                I certify that, to the best of my knowledge, the child/children are in good physical condition
                and do not have any medical condition that may increase the likelihood of being involved
                in an incident resulting in injury to themselves. (If in any doubt, I will verify with the child/
                children’s parent or guardian.)<br>
                I certify that the child/children have no pre-existing medical conditions that could result
                in injury or harm to their health through participation.<br>
                I acknowledge that the maximum permitted weight for participation is 135kg, and
                confirm that the child/children do not exceed this weight.<br>
                I acknowledge that I am responsible for assessing the suitability of the Activity for the
                child/children in my care.<br>
          </p>
          <p class="WhiteStandard-text">
              <b>Acknowledgment of Risk (All Participants)</b><br>
              I understand that SimPark does not assess individual participants’ abilities or the suitability
              of the Activity for any individual. All participants, parents, and guardians must make their
              own assessment of whether the Activity is appropriate and whether the participant is
              capable of safely taking part.<br>
              I understand that the Activity is physically demanding and is a high-impact, full-body
              experience requiring intense focus and awareness of personal physical limits.<br>
              I understand that using the Activity involves increased inherent risk, and that I/he/she/
              they participate entirely at my/their own risk.<br>
          </p>
          <p class="WhiteStandard-text">
              <b>Risks Associated with Simulator Use</b><br>
              I understand that participation may result in personal injury—particularly if the equipment is not
              used correctly—including but not limited to:<br>
              • muscle strains
              • sprains
              • dislocations
              • other injuries associated with high-force motion systems
              <b>Race simulators used at SimPark are designed to replicate professional motorsport
              environments, using:</b><br>
              • professional direct-drive force-feedback systems
              • haptic technology
              • full-motion components
              • flashing lights, images, and video content
              Due to these features, the simulators may not be suitable for:<br>
              • pregnant guests
              • elderly guests
              • guests with heart conditions, high blood pressure, or aneurysms
              • individuals with recent surgery or illness
              • individuals with neck, back, or bone issues
              • individuals with epilepsy or photosensitivity (due to visual effects)
              • individuals prone to motion sickness<br>
              Guests in these categories should consult a physician before using the simulators.<br>
              By using the facility, you assume all risks associated with simulator use. SimPark is not liable
              for injuries or damage to personal property except in cases of gross negligence.<br>
              I accept that such injuries may occur through normal use of the equipment and not necessarily as a
              result of defective equipment or negligence by the Company.<br>
              I understand and accept that the Activity requires a moderate level of fitness and should not be
              undertaken unless I/he/she/they am/are physically able to do so.<br>
              I understand that I/he/she/they am/are responsible for my/their own actions while using the Activity.
              I understand that SimPark does not provide direct supervision of participants and does not provide
              training or tuition in the use of the Activity.<br>
              I understand that SimPark does not assess any participant’s skill level, abilities, competency, or the
              suitability of the Activity for their use.<br>
              In the unlikely event of an accident, I acknowledge that the Company will not be liable for any
              direct or indirect loss, damage, or injury arising from or connected to the Activity (except in cases
              of death or personal injury caused by the Company’s negligence). I waive all claims against the
              Company in this respect.<br>
              I confirm that I (and the child/children in my care, where relevant) have read, fully understand, and
              voluntarily accept these terms of participation without any inducement prior to signing/submitting
              this form.<br>
              I acknowledge and accept that CCTV images of all park entrants are monitored and recorded
              throughout the premises for the purposes of crime prevention and public safety.
          </p>
        </div>
        <b-form-checkbox
            id="checkbox-2"
            v-model="terms"
            name="checkbox-2"
            value="Y"
            unchecked-value="N"
            class="check"
        >
            <span class="gift">
                I accept the Terms
            </span>
        </b-form-checkbox>
        <div class="buttonSec">
          <template>
          <template v-if="AdultFirstNameName != '' && AdultPhone != '' && AdultEmail.includes('@')">
              <button v-b-modal.modal-1 class="showMore fullWidth" @click="submitWaiver()">Submit Waiver</button>
          </template>
          <template v-else>
              <button class="showMore dis fullWidth" disabled>Submit Waiver</button>
          </template>
          </template>
        </div>
      </template>
      <template v-else>
          <template v-if="respWaiver.status == 'FAIL'">
            <h2 class="thankyou" v-html="respWaiver.message"></h2>
          </template>
          <template v-else>
            <h2 class="thankyou">Thank you for registering</h2>
          </template>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as CryptoJS from 'crypto-js';
export default {
  name: 'Waiver',
  components: {
  },
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
      acf: [],
      showButton: true,
      showDiv: false,
      AdultFirstName: '',
      AdultSurnameName: '',
      AdultPhone: '',
      AdultEmail: '',
      AdultDOB: '',
      recipientName: '',
      recipientDOB: '',
      status: 'N',
      terms: 'N',
      cryptoAES: CryptoJSAesJson,
      row: [
        {
        nameForename: '',
        nameSurname: '',
        dob: ''
        },
      ],
      waiverData: {},
      thankyouMessage: 'N',
      respWaiver: []
    };
  },
  methods: {
    removeRow: function(index){
      console.log(index);
      this.row.splice(index);
    },
    addRow: function(){
      this.row.push({});
    },
    addMinor: function(index) {
      console.log('add Minor')
      console.log(index)
    },
    submitWaiver() {
      let sktMsg = this.waiverInfo()
      console.log("sktMsg")
      console.log(sktMsg)
      this.waiverResponse();
      this.$socket.emit('sradd', sktMsg);
      this.thankyouMessage = 'Y' 
      setTimeout(function(){

      window.location = 'https://racepark.club/waiver';

      },5000)
    },
    waiverResponse() {
			this.sockets.subscribe('respsradd', (data) => {
        const jsonDoc = JSON.parse(data);
        this.respWaiver = jsonDoc
        console.log("jsonDoc")
        console.log(jsonDoc)
			});
    },
    waiverInfo() {
        console.log('IN')
        const dateString = this.AdultDOB;
        const [day, month, year] = dateString.split("-");  
        // Only way to get the below to work was to reverse the login in american format
        let multiPeople = []
        console.log("multiPeople")
        console.log(multiPeople)
        this.peopleMulti = multiPeople;
        this.row.forEach((value) => {
            multiPeople.push(value);
        });

        let sktMsg = '';  

				sktMsg += 'EG' + ' ';
				sktMsg += "'";
				sktMsg += this.AdultFirstName + '~'; // forename
				sktMsg += this.AdultSurnameName + '~'; // surname
				sktMsg += this.AdultPhone  + '~'; // phone
				sktMsg += this.AdultEmail + '~'; // email
				sktMsg += '~'; // password
				sktMsg += '~'; // gender
				sktMsg += 'A~'; // memb type
				sktMsg += '~'; // cdh number, not used
				sktMsg += '~'; // consent
				sktMsg += this.status + '~'; // guardian
        sktMsg += year + month + day + '~';
				sktMsg += 'Y~'; // terms agree
				sktMsg += '2000029000' + '~'; // venue code
				sktMsg += '~'; // nationality
				sktMsg += '~'.repeat(7);
				sktMsg += 'N~';
				sktMsg += '~'; // title
				sktMsg += '~'; // notes
        if (this.status == 'Y') {
          for (const i of this.peopleMulti) {
          const dateString =  i.dob;
          const [day, month, year] = dateString.split("-");  
            sktMsg += i.nameForename + '^^' + i.nameSurname + '^^' + day + '-' + month + '-' + year + '<!/D>';
          }     
        }
				sktMsg += "'";

        return sktMsg 
	}, 
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    myFunction() {
      this.showDiv = true
      this.showButton = false
        // var x = document.getElementById("myDIV");
        // if (x.style.display === "none") {
        //     this.show = false
        //     x.style.display = "block";
        // } else {
        //     x.style.display = "none";
        // }
    }
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'racepark' + "/wp-json/wp/v2/pages/6"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
h2.thankyou {
  color: #000;
  padding-top: 50px;
  padding-bottom: 100px;
}
img.crossRow {
  position: relative;
  top: 5px;
}
.cross {
  background-color: #4E4E4E;
  border-radius: 27px;
  width: 91px;
  height: 38px;
  vertical-align: bottom;
  margin-top: 39px;
  float: right;
  cursor: pointer;
}
.minorButton {
  margin-top: 30px;
}
.buttonSec {
    margin-top: 20px;
}
p.nonParent {
    margin-top: 30px;
    margin-bottom: 30px;
}
::v-deep label.custom-control-label {
    color: #000;
}
::v-deep label.d-block {
    text-align: left;
    color: #000;
    font-weight: bold;
    margin-top: 0.5em;
}
.formBlockSection {
    margin-top: 30px;
}
button.showMore.dis.fullWidth {
    width: 75%;
    background-color: grey;
}
button.showMore.fullWidth {
    width: 75%;
}
.custom-control {
    position: relative;
    z-index: 1;
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5rem;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    print-color-adjust: exact;
    text-align: left;
}
label {
    display: inline-block;
    margin-bottom: 0.5rem;
    text-align: left;
    font-weight: bold;
    margin-top: 0.5em;
}
.form {
    color: #000000;
    text-align: left;
}
button.showMore {
    background: #D80E1F;
    border-radius: 27px;
    border: #D80E1F;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    width: 200px;
    padding: 5px;
    margin-bottom: 20px;
    margin-top: 30px;
}
#myDIV {
    display: none;
}
h2.ContactTitle.Terms {
    padding-bottom: 20px;
}
.title {
  color: black;
}
.ContactSection {
  /* background-color: #1A1A1A; */
}
.ContactTitle {
  color: #11182F;
  font-size: 40px;
  padding-top: 80px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
  font-style: italic;
  text-align: left;
  padding-bottom: 50px;
}
.WhiteStandard-text {
  font-size: 20px;
  color: #11182F;
  font-family: "noto-sans", sans-serif;
  font-weight: 400;
  font-style: normal;
  text-align: left;
}
.contact-width {
  width: 70%;
  text-align: left;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 70px;
}
p.redTitle {
    color: #DD112B;
    font-weight: bold;
    font-size: 22px;
    text-align: left;
    margin-bottom: 0px;
}
@media only screen and (max-width: 768px) {
  .ContactTitle {
    color: #11182F;
    font-size: 40px;
  }
  .WhiteStandard-text {
    font-size: 20px;
    color: #11182F;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .imagesInsert {
    width: 100%;
  }
}
</style>
